import { render, staticRenderFns } from "./FirmaKorisnici.vue?vue&type=template&id=1837bba8&scoped=true"
import script from "./FirmaKorisnici.vue?vue&type=script&lang=js"
export * from "./FirmaKorisnici.vue?vue&type=script&lang=js"
import style0 from "./FirmaKorisnici.vue?vue&type=style&index=0&id=1837bba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1837bba8",
  null
  
)

export default component.exports